export default __webpack_public_path__ + "static/media/control-stop-180.aed41c44.png";